{
  "name": "g3w-client",
  "version": "4.2.0-beta.0",
  "description": "Gis3W WebGIS Client",
  "main": "index.js",
  "scripts": {
    "preinstall": "",
    "prepare": "git config core.hooksPath .githooks",
    "build": "node build.js build",
    "build:ci": "node build.js build:ci",
    "dev": "node build.js dev",
    "docker": "docker compose --env-file ../g3w-suite-docker/.env --file ../g3w-suite-docker/docker-compose-dev.yml --project-name g3w-suite-docker --project-directory ../g3w-suite-docker",
    "docker:pull": "npm run docker pull",
    "docker:up": "npm run docker up -- -d",
    "docker:down": "npm run docker down",
    "docker:config": "npm run docker config",
    "docker:logs": "npm run docker logs",
    "test": "node test/dev.g3wsuite.it.js",
    "preversion": "npm run test",
    "version": "npm run build && git add -A",
    "postversion": "git push && git push --tags"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/g3w-suite/g3w-client.git"
  },
  "author": "",
  "license": "MPL-2.0",
  "homepage": "https://github.com/g3w-suite/g3w-client.git",
  "dependencies": {
    "@fortawesome/fontawesome-free": "^5.15.4",
    "fflate": "^0.8.2",
    "invokers-polyfill": "^0.5.5",
    "jsts": "^2.11.3",
    "ol": "^10.11.0",
    "proj4": "^2.19.6",
    "temporal-polyfill": "^1.0.5",
    "vue": "2.7.16"
  },
  "devDependencies": {
    "@vue/compiler-sfc": "2.7.16",
    "esbuild": "^0.28.2",
    "playwright": "^1.55.0"
  },
  "engines": {
    "node": ">=22.9.0",
    "npm": ">=10.8.3"
  }
}
